<template>
  <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
    <a-form :layout="formLayout" :form="form" style="margin-top:1em;">
      <a-form-item
        :label="varLabel"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-transfer
          :dataSource="varAllScopes"
          :listStyle="{
              width: '350px',
              height: '350px',
            }"
          :titles="varTitles"
          :targetKeys="targetKeys"
          :selectedKeys="selectedKeys"
          @change="handleChange"
          @selectChange="handleSelectChange"
          :render="item => item.resource_name+'-'+item.permission"
          :disabled="disabled"
        />
      </a-form-item>
      <a-form-item :wrapper-col="buttonItemLayout.wrapperCol" style="margin-top:0.5em;">
        <a-button type="primary" shape="round" size="large" @click="handleSubmit">Update Details</a-button>
      </a-form-item>
    </a-form>
  </a-skeleton>
</template>

<script>
import { formLayoutMixin } from "@/mixins/formLayout";

export default {
  data() {
    return {
      selectedKeys: [],
      varTitles: ["All", "Selected"],
      targetKeys: [],
      selectedScopes: [],
      varAllScopes: [],
      formLayout: "vertical",
      loading: true
    };
  },
  mixins: [formLayoutMixin],
  props: {
    varLabel: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];

      console.log("sourceSelectedKeys: ", sourceSelectedKeys);
      console.log("targetSelectedKeys: ", targetSelectedKeys);
    },
    handleChange(targetKeys, direction, moveKeys) {
      console.log(targetKeys, direction, moveKeys);
      this.targetKeys = targetKeys;
    },
    async handleSubmit() {
      try {
        this.loading = true;
        await this.$store.dispatch("tenant/patchItem", {
          endpoint: "roles",
          uuid: this.$route.params.uuid,
          data: { 'scopes' : this.targetKeys }
        });
        this.targetKeys = this.$store.state.tenant.roles_item.scopes;
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    }
  },
  computed: {
    message() {
      return `Please enter ${this.varLabel.toLowerCase()}`;
    }
  },
  beforeCreate: async function() {
    this.form = this.$form.createForm(this);
    try {
      await this.$store.dispatch("tenant/getItems", {
        endpoint: "scopes"
      });
      this.targetKeys = this.$store.state.tenant.roles_item.scopes;
      this.varAllScopes = this.$store.state.tenant.scopes;
      this.varAllScopes = this.varAllScopes.map(record => {
        record.key = record.uuid;
        record.title = record.resource_name + "-" + record.permission;
        return record;
      });
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  }
};
</script>
